import { Grid, Typography } from '@mui/material';
import { LoadingButton } from '../utils';
import RefreshIcon from '@mui/icons-material/Refresh';

interface ShippingRefreshBoxesProps {
  loadBoxesForShipping: (forceRefresh: boolean) => Promise<void>;
  loading: boolean;
  geoErrorMessage: string;
}

export function ShippingRefreshBoxes({ loadBoxesForShipping, loading, geoErrorMessage }: ShippingRefreshBoxesProps) {
  return (
    <>
      <Grid
        size={{
          xs: 6,
          sm: 1,
        }}
      >
        <LoadingButton variant="outlined" onClick={async () => await loadBoxesForShipping(true)} loading={loading}>
          1. Refresh
          <RefreshIcon style={{ marginLeft: 7.5 }} fontSize="small" />
        </LoadingButton>
      </Grid>
      <Grid
        size={{
          xs: 6,
          sm: 2,
        }}
      >
        <Typography>{geoErrorMessage}</Typography>
      </Grid>
    </>
  );
}
